import React, { ReactNode } from 'react';
import { LeftBorderTitle } from '@doda/io-react/common';
import styles from './index.module.scss';

/**
 * SubSectionのprops
 */
interface SubSectionProps {
  /** 青い縦棒の見出しと説明の配列 */
  label: string;
  children: ReactNode;
}

/**
 * SubSection コンポーネント
 */
export const SubSection: React.FC<SubSectionProps> = ({ label, children }) => {
  return (
    <div>
      <LeftBorderTitle as="div" size="S">
        {label}
      </LeftBorderTitle>
      <div className={styles['jobSearchDetail-subSection__description']}>
        {children}
      </div>
    </div>
  );
};
